import { Controller, get } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { RadioButton } from 'primereact/radiobutton';

export default function RadioInput({
  label,
  name,
  options,
  inputField,
  renderField,
  defaultValue,
  isRequired,
  disabled,
  control,
  errors,
  onRadioChange,
}) {
  const { t } = useTranslation();

  return (
    <div className="field">
      <label
        className={classNames('mb-2', { hidden: !label, 'inline-block': label })}
        htmlFor={name}
      >
        {label}{' '}
        {isRequired && (
          <span className="text-red-500" style={{ fontWeight: 900 }}>
            *
          </span>
        )}
      </label>
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={name}
        render={({ field: { onChange, value, ref } }) => (
          <div className="flex flex-wrap gap-3">
            {options.map((option) => (
              <div key={option[inputField]} className="flex align-items-center">
                <RadioButton
                  id={`${name}-${option[inputField]}`}
                  inputRef={ref}
                  name={name}
                  value={option[inputField]}
                  onChange={(e) => {
                    onChange(e.value);
                    onRadioChange(name, e.value);
                  }}
                  checked={value === option[inputField]}
                  disabled={disabled}
                  className={classNames({ 'p-invalid': !!get(errors, name) }, 'mr-1')}
                />
                <label htmlFor={`${name}-${option[inputField]}`}>{option[renderField]}</label>
              </div>
            ))}
          </div>
        )}
      />
      {get(errors, name) && <small className="p-invalid">{t(get(errors, name)?.message)}</small>}
    </div>
  );
}

RadioInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.array.isRequired,
  inputField: PropTypes.string,
  renderField: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  defaultValue: PropTypes.any,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  onRadioChange: PropTypes.func,
};

RadioInput.defaultProps = {
  label: '',
  inputField: 'id',
  renderField: 'name',
  defaultValue: undefined,
  isRequired: false,
  disabled: false,
  onRadioChange: () => null,
};
